import { queryOptions, useQuery } from '@tanstack/react-query'
import fetcher from '../lib/fetcher'
import { APIResponse, City, Country, State } from '../types/utils'
import { useState } from 'react'

export const getCountriesQueryOptions = () =>
  queryOptions({
    queryKey: ['countries'],
    queryFn: async () => {
      return await fetcher
        .get(import.meta.env.VITE_API_BOOKING + `utils/geo/countries`)
        .json<APIResponse<Country[]>>()
    },
    staleTime: Infinity,
  })

export const getStatesQueryOptions = (country?: string) =>
  queryOptions({
    queryKey: ['states', country],
    queryFn: async () => {
      return await fetcher
        .get(
          import.meta.env.VITE_API_BOOKING +
            `utils/geo/states?country=${country}`
        )
        .json<APIResponse<State[]>>()
    },
    enabled: !!country,
  })

export const getCitiesQueryOptions = (state?: number, country?: string) =>
  queryOptions({
    queryKey: ['cities', state, country],
    queryFn: async () => {
      return await fetcher
        .get(
          import.meta.env.VITE_API_BOOKING +
            `utils/geo/cities?state=${state}&country=${country}`
        )
        .json<APIResponse<City[]>>()
    },
    enabled: !!state && !!country,
  })

function useGeo() {
  const [state, setState] = useState<number | undefined>()
  const [country, setCountry] = useState<string | undefined>()
  const countriesResult = useQuery(getCountriesQueryOptions())
  const statesResults = useQuery(getStatesQueryOptions(country))
  const citiesResults = useQuery(getCitiesQueryOptions(state, country))

  const resetStates = () => {
    setState(undefined)
  }
  const resetCountry = () => {
    setCountry(undefined)
    setState(undefined)
  }

  return {
    countries: countriesResult.data?.data ?? [],
    states: statesResults.data?.data ?? [],
    cities: citiesResults.data?.data ?? [],
    setCountry,
    setState,
    resetStates,
    resetCountry,
  }
}

export default useGeo
